/**
 *
 * @param {*} data - all routing data - Array
 */
export const modifyData = (allCommunicationData = []) => {
  return allCommunicationData.map(item => {
    const { headline: cardText = '', displayButton: showButton = false } = item.fields;
    // get all button realted inforamtions
    const {
      buttonText = '',
      name: buttonItem = '',
      url: buttonUrl = '',
    } = (item.fields.button && item.fields.button.fields) || {};
    // get all image realted inforamtions
    const { url: src = '', alt = '' } =
      (item.fields.desktopImage && item.fields.desktopImage.fields && item.fields.desktopImage.fields.file) || {};
    return { cardText, showButton, buttonText, buttonItem, buttonUrl, src, alt };
  });
};
